import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import {
  UserActionTypes,
  ActionUserCreate
} from './types';
import { User } from '../../models/user';

export const dispatchUserCreate = (payload: User): ActionUserCreate => {
  return {
    type: UserActionTypes.ACTION_USER_CREATE,
    payload,
  };
};

// Action Creators
export const actionCreateUser = (payload: User) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchUserCreate(payload));
  };
};
